import { render, staticRenderFns } from "./Wall.vue?vue&type=template&id=2299fae9&"
import script from "./Wall.vue?vue&type=script&lang=js&"
export * from "./Wall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports